import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getTransmissionDemandDetail } from "../services/institutionService";
import { TransmissionDemandDetail } from "../types/institution";

export const useTransmissionDemandDetail = (transmissionDemandId: string) => {
  const [detail, setDetail] = useState<TransmissionDemandDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getTransmissionDemandDetail(transmissionDemandId);
      setDetail(response);
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "전송요구서 상세 정보를 불러오는데 실패했습니다.";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (transmissionDemandId) {
      fetchDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transmissionDemandId]);

  return {
    detail,
    loading,
    error,
    refetch: fetchDetail,
  };
};
